const SERVICES_CONFIG = {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  HEADERS: { headers: { contentType: 'multipart/form-data' } },
  HEADERS_AUTH: {}
}

export default SERVICES_CONFIG;
